/* ============================================================
 * QUIKLOX Configurator — "Build Your QUIKLOX"
 * ------------------------------------------------------------
 * Vanilla JS state machine + renderer, GUIDATO DALLE COLLEZIONI.
 *
 * Flow (3 steps):
 *   1. Scegli la staffa   (tutti i prodotti della collezione "supports";
 *                          filtro opzionale a pillole per tag: Moto/Scooter/Bici/Auto)
 *   2. Scegli la custodia  (tutti i prodotti della collezione "cases";
 *                          prodotti multi-variante = dropdown modello)
 *   3. Accessori           (tutti i prodotti della collezione "accessories")
 *
 * Legge un solo blob JSON dalla pagina:
 *   #qx-shopify-data -> { supports:[...], cases:[...], accessories:[...] }
 *   (generato da snippets/quiklox-products-data.liquid dalle 3 collezioni)
 *
 * Add-to-cart: POST /cart/add.js con items[].
 * ============================================================ */

(function () {
  'use strict';

  // Filtri use-case (derivati dai tag prodotto). Mostrati solo se presenti.
  var USE_CASE_TAGS = [
    { tag: 'Moto',        label: 'Moto',    icon: '🏍️' },
    { tag: 'Scooter',     label: 'Scooter', icon: '🛵' },
    { tag: 'Bicicletta',  label: 'Bici',    icon: '🚴' },
    { tag: 'Auto',        label: 'Auto',    icon: '🚗' }
  ];

  function readJsonScript(id) {
    var el = document.getElementById(id);
    if (!el) throw new Error('Missing data script: #' + id);
    try { return JSON.parse(el.textContent.trim()); }
    catch (err) { console.error('[QUIKLOX] Invalid JSON in #' + id, err); throw err; }
  }

  function money(amountCents) {
    if (amountCents == null || isNaN(amountCents)) return '—';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var locale = (window.Shopify && window.Shopify.locale) || 'it';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amountCents / 100);
    } catch (_) {
      return currency + ' ' + (amountCents / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function firstVariant(p) { return p && p.variants && p.variants[0] ? p.variants[0] : null; }
  function isMultiVariant(p) { return p && p.variants && p.variants.length > 1; }

  // ---------- Configurator ---------------------------------------------

  function Configurator(rootEl, data) {
    this.root = rootEl;
    this.supports = (data && data.supports) || [];
    this.cases = (data && data.cases) || [];
    this.accessories = (data && data.accessories) || [];

    // Lookups by handle
    this.byHandle = {};
    var all = this.supports.concat(this.cases, this.accessories);
    all.forEach(function (p) { this.byHandle[p.handle] = p; }, this);

    this.steps = ['support', 'cases', 'extras'];

    this.state = {
      step: 'support',
      tagFilter: null,          // filtro use-case (tag) dello step staffa
      supportHandles: [],       // multi-select supporti
      caseChoices: [],          // [{ handle, variantId, title, image, price_cents }]
      caseVariantSel: {},       // { handle: variantId } scelta corrente dropdown
      accessoryHandles: []      // multi-select accessori
    };

    this.els = {
      stepper: rootEl.querySelector('#qx-stepper'),
      steps:   rootEl.querySelector('#qx-steps'),
      summaryList: rootEl.querySelector('#qx-summary-list'),
      total:   rootEl.querySelector('#qx-total'),
      addBtn:  rootEl.querySelector('#qx-add-to-cart')
    };

    this.els.addBtn.addEventListener('click', this.addToCart.bind(this));
  }

  // ---------- Helpers per le custodie ----------------------------------

  Configurator.prototype.getCaseByHandle = function (handle) {
    return this.cases.find(function (c) { return c.handle === handle; });
  };

  Configurator.prototype.getCaseVariant = function (p, variantId) {
    if (!p) return null;
    if (isMultiVariant(p)) {
      var v = p.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (!v) return null;
      return { variantId: v.id, sku: v.sku, price_cents: v.price_cents, available: v.available,
               title: v.title, image: v.image || p.image || null };
    }
    var fv = firstVariant(p);
    if (!fv) return null;
    return { variantId: fv.id, sku: fv.sku, price_cents: fv.price_cents, available: fv.available,
             title: p.title, image: p.image || fv.image || null };
  };

  Configurator.prototype.findCaseChoiceIdx = function (handle) {
    return this.state.caseChoices.findIndex(function (c) { return c.handle === handle; });
  };

  // ---------- State actions --------------------------------------------

  Configurator.prototype.setStep = function (step) {
    this.state.step = step;
    this.render();
    if (window.innerWidth <= 960) {
      this.els.steps.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Filtro use-case (non è uno step): non resetta la selezione, non avanza.
  Configurator.prototype.setTagFilter = function (tag) {
    this.state.tagFilter = tag || null;
    this.render();
  };

  Configurator.prototype.toggleSupport = function (handle) {
    var idx = this.state.supportHandles.indexOf(handle);
    if (idx > -1) this.state.supportHandles.splice(idx, 1);
    else this.state.supportHandles.push(handle);
    this.render();
  };

  Configurator.prototype.continueToCases = function () {
    if (this.state.supportHandles.length === 0) return;
    this.setStep('cases');
  };

  Configurator.prototype.continueToExtras = function () {
    this.setStep('extras');
  };

  Configurator.prototype.toggleAccessory = function (handle) {
    var idx = this.state.accessoryHandles.indexOf(handle);
    if (idx > -1) this.state.accessoryHandles.splice(idx, 1);
    else this.state.accessoryHandles.push(handle);
    this.render();
  };

  Configurator.prototype.setCaseVariant = function (handle, variantId) {
    this.state.caseVariantSel[handle] = variantId;
    var idx = this.findCaseChoiceIdx(handle);
    if (idx > -1) {
      var p = this.getCaseByHandle(handle);
      var v = this.getCaseVariant(p, variantId);
      if (v) {
        this.state.caseChoices[idx] = { handle: handle, variantId: v.variantId, title: v.title,
                                        image: v.image, price_cents: v.price_cents };
      }
    }
    this.render();
  };

  Configurator.prototype.toggleCase = function (handle) {
    var p = this.getCaseByHandle(handle);
    if (!p) return;
    var idx = this.findCaseChoiceIdx(handle);
    if (idx > -1) { this.state.caseChoices.splice(idx, 1); this.render(); return; }

    var variantId = null;
    if (isMultiVariant(p)) {
      variantId = this.state.caseVariantSel[handle];
      if (!variantId) return; // modello non ancora scelto
    }
    var v = this.getCaseVariant(p, variantId);
    if (!v) return;
    this.state.caseChoices.push({ handle: handle, variantId: v.variantId, title: v.title,
                                  image: v.image, price_cents: v.price_cents });
    this.render();
  };

  // ---------- Selected items (summary & cart) --------------------------

  Configurator.prototype.getSelectedItems = function () {
    var items = [];
    var self = this;

    this.state.supportHandles.forEach(function (handle) {
      var p = self.byHandle[handle];
      var v = firstVariant(p);
      if (!p || !v) return;
      items.push({ variantId: v.id, cat: 'Supporto', title: p.title, image: p.image,
                   price_cents: p.price_cents,
                   remove: function () { self.toggleSupport(handle); } });
    });

    this.state.caseChoices.forEach(function (cc) {
      items.push({ variantId: cc.variantId, cat: 'Custodia', title: cc.title, image: cc.image,
                   price_cents: cc.price_cents,
                   remove: function () { self.toggleCase(cc.handle); } });
    });

    this.state.accessoryHandles.forEach(function (handle) {
      var p = self.byHandle[handle];
      var v = firstVariant(p);
      if (!p || !v) return;
      items.push({ variantId: v.id, cat: 'Accessorio', title: p.title, image: p.image,
                   price_cents: p.price_cents,
                   remove: function () { self.toggleAccessory(handle); } });
    });

    return items;
  };

  // ---------- Cart -----------------------------------------------------

  Configurator.prototype.addToCart = function () {
    var items = this.getSelectedItems();
    if (items.length === 0) return;

    this.els.addBtn.disabled = true;
    this.els.addBtn.textContent = 'Aggiunta in corso…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items.map(function (i) { return { id: i.variantId, quantity: 1 }; }) })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Errore carrello'); });
        return r.json();
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        console.error('[QUIKLOX] Add to cart failed', err);
        this.els.addBtn.disabled = false;
        this.els.addBtn.textContent = 'Aggiungi il kit al carrello';
        alert('Impossibile aggiungere al carrello: ' + err.message);
      }.bind(this));
  };

  // ---------- Render ---------------------------------------------------

  Configurator.prototype.render = function () {
    this.renderStepper();
    this.renderSteps();
    this.renderSummary();
  };

  Configurator.prototype.renderStepper = function () {
    var s = this.state;
    var labels = {
      support: { num: '1', label: 'Scegli la staffa' },
      cases:   { num: '2', label: 'Scegli la custodia' },
      extras:  { num: '3', label: 'Accessori' }
    };
    var completed = {
      support: s.supportHandles.length > 0,
      cases:   s.caseChoices.length > 0,
      extras:  s.accessoryHandles.length > 0
    };
    this.els.stepper.innerHTML = '';
    var self = this;
    this.steps.forEach(function (key) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qx-stepper__item';
      btn.setAttribute('data-complete', completed[key]);
      if (s.step === key) btn.setAttribute('aria-current', 'step');
      btn.innerHTML = '<span class="qx-stepper__num">Step ' + labels[key].num + '</span>' +
                      '<span class="qx-stepper__label">' + labels[key].label + '</span>';
      btn.addEventListener('click', function () { self.setStep(key); });
      self.els.stepper.appendChild(btn);
    });
  };

  Configurator.prototype.renderSteps = function () {
    var html = '';
    html += this.renderSupportStep();
    html += this.renderCaseStep();
    html += this.renderExtrasStep();
    this.els.steps.innerHTML = html;
    this.attachStepHandlers();
  };

  // Link "info" (apre la scheda prodotto in una nuova scheda)
  Configurator.prototype.infoLink = function (p) {
    if (!p.url) return '';
    return '<a class="qx-card__info" href="' + p.url + '" target="_blank" rel="noopener" title="Vedi la scheda prodotto" aria-label="Vedi la scheda prodotto">' +
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>' +
      '</a>';
  };

  // ----- Card generica prodotto (supporti / accessori, single-variant) -----
  Configurator.prototype.renderSimpleCard = function (p, action, selected) {
    var available = !!p.available;
    var html = '<div class="qx-card-wrap">';
    html += this.infoLink(p);
    html += '<button type="button" class="qx-card" data-action="' + action + '" data-handle="' + p.handle + '" aria-pressed="' + selected + '"' + (available ? '' : ' aria-disabled="true" disabled') + '>';
    if (selected) html += '<div class="qx-card__badge qx-card__badge--selected">✓ Aggiunto</div>';
    if (p.image) html += '<img class="qx-card__img" src="' + p.image + '" alt="" loading="lazy">';
    else html += '<div class="qx-card__img"></div>';
    html += '<h3 class="qx-card__name">' + escapeHtml(p.title) + '</h3>';
    if (available) html += '<div class="qx-card__price">' + money(p.price_cents) + '</div>';
    else html += '<div class="qx-card__price qx-card__price--soldout">Non disponibile</div>';
    html += '</button>';
    html += '</div>';
    return html;
  };

  Configurator.prototype.renderSupportStep = function () {
    var s = this.state;
    var active = s.step === 'support';
    var html = '<section class="qx-step" data-active="' + active + '" data-step="support">';
    html += '<h2 class="qx-step__heading">Scegli la staffa</h2>';
    html += '<p class="qx-step__hint">Seleziona uno o più supporti da aggiungere al kit. Usa i filtri per restringere per tipo di utilizzo.</p>';

    // Pillole filtro use-case (solo quelle presenti nei prodotti)
    var self = this;
    var available = USE_CASE_TAGS.filter(function (uc) {
      return self.supports.some(function (p) { return (p.tags || []).indexOf(uc.tag) > -1; });
    });
    if (available.length) {
      html += '<div class="qx-filters">';
      html += '<button type="button" class="qx-filter' + (!s.tagFilter ? ' is-active' : '') + '" data-action="set-filter" data-id="">Tutti</button>';
      available.forEach(function (uc) {
        var on = s.tagFilter === uc.tag;
        html += '<button type="button" class="qx-filter' + (on ? ' is-active' : '') + '" data-action="set-filter" data-id="' + uc.tag + '">' + uc.icon + ' ' + escapeHtml(uc.label) + '</button>';
      });
      html += '</div>';
    }

    html += '<div class="qx-grid">';
    var list = this.supports.filter(function (p) {
      return !s.tagFilter || (p.tags || []).indexOf(s.tagFilter) > -1;
    });
    if (list.length === 0) html += '<p class="qx-step__hint">Nessun supporto per questo filtro.</p>';
    list.forEach(function (p) {
      html += self.renderSimpleCard(p, 'toggle-support', s.supportHandles.indexOf(p.handle) > -1);
    });
    html += '</div>';

    var canContinue = s.supportHandles.length > 0;
    html += '<div class="qx-step__footer">';
    html += '<button type="button" class="qx-btn qx-btn--continue" data-action="continue-to-cases"' + (canContinue ? '' : ' disabled') + '>';
    html += canContinue ? 'Continua con ' + s.supportHandles.length + ' supporto' + (s.supportHandles.length > 1 ? 'i' : '') + ' &rarr;' : 'Seleziona almeno un supporto';
    html += '</button></div>';

    html += '</section>';
    return html;
  };

  Configurator.prototype.renderCaseStep = function () {
    var s = this.state;
    var active = s.step === 'cases';
    var self = this;
    var html = '<section class="qx-step" data-active="' + active + '" data-step="cases">';
    html += '<h2 class="qx-step__heading">Scegli la custodia</h2>';
    html += '<p class="qx-step__hint">Le custodie universali si adattano a qualsiasi telefono; quelle dedicate ti fanno scegliere il modello. Passo opzionale.</p>';

    html += '<div class="qx-grid">';
    this.cases.forEach(function (p) { html += self.renderCaseCard(p); });
    html += '</div>';

    html += '<div class="qx-step__footer">';
    html += '<button type="button" class="qx-btn qx-btn--continue" data-action="continue-to-extras">Continua &rarr;</button>';
    html += '</div>';

    html += '</section>';
    return html;
  };

  Configurator.prototype.renderCaseCard = function (p) {
    var s = this.state;
    var multi = isMultiVariant(p);
    var inKit = this.findCaseChoiceIdx(p.handle) > -1;
    var selVariantId = s.caseVariantSel[p.handle] || null;

    var preview = multi ? (selVariantId ? this.getCaseVariant(p, selVariantId) : null)
                        : this.getCaseVariant(p, null);
    var image = (preview && preview.image) || p.image || null;
    var price = preview ? preview.price_cents : p.price_cents;
    var available = preview ? preview.available : p.available;
    var canAdd = multi ? (!!selVariantId && !!available) : !!available;

    var html = '<div class="qx-card qx-card--cover" aria-pressed="' + (inKit ? 'true' : 'false') + '">';
    html += this.infoLink(p);
    if (!multi) html += '<div class="qx-card__badge">Universale</div>';
    if (image) html += '<img class="qx-card__img" src="' + image + '" alt="" loading="lazy">';
    else html += '<div class="qx-card__img"></div>';
    html += '<h3 class="qx-card__name">' + escapeHtml(p.title) + '</h3>';

    if (multi) {
      html += '<label class="qx-cover-card__label" for="qx-var-' + p.handle + '">Scegli il modello</label>';
      html += '<select class="qx-cover-card__select" id="qx-var-' + p.handle + '" data-action="set-case-variant" data-handle="' + p.handle + '">';
      html += '<option value="">Scegli un modello…</option>';
      p.variants.forEach(function (v) {
        var sel = String(selVariantId) === String(v.id) ? ' selected' : '';
        var suffix = v.available ? '' : ' (esaurito)';
        html += '<option value="' + v.id + '"' + sel + (v.available ? '' : ' disabled') + '>' + escapeHtml(v.title + suffix) + '</option>';
      });
      html += '</select>';
    }

    html += '<div class="qx-card__price">';
    if (price != null && (multi ? selVariantId : true) && available) html += money(price);
    else if (multi && !selVariantId) html += '<span class="qx-card__price--muted">Scegli un modello per il prezzo</span>';
    else html += '<span class="qx-card__price--soldout">Non disponibile</span>';
    html += '</div>';

    var ctaLabel = inKit ? 'Rimuovi dal kit' : 'Aggiungi al kit';
    var ctaDisabled = !inKit && !canAdd;
    html += '<button type="button" class="qx-cover-card__cta' + (inKit ? ' qx-cover-card__cta--remove' : '') + '" data-action="toggle-case" data-handle="' + p.handle + '"' + (ctaDisabled ? ' disabled' : '') + '>';
    html += inKit ? '✓ ' + escapeHtml(ctaLabel) : escapeHtml(ctaLabel);
    html += '</button>';

    html += '</div>';
    return html;
  };

  Configurator.prototype.renderExtrasStep = function () {
    var s = this.state;
    var active = s.step === 'extras';
    var self = this;
    var html = '<section class="qx-step" data-active="' + active + '" data-step="extras">';
    html += '<h2 class="qx-step__heading">Accessori</h2>';
    html += '<p class="qx-step__hint">Aggiungi gli accessori opzionali al tuo kit.</p>';

    html += '<div class="qx-grid">';
    if (this.accessories.length === 0) html += '<p class="qx-step__hint">Nessun accessorio disponibile.</p>';
    this.accessories.forEach(function (p) {
      html += self.renderSimpleCard(p, 'toggle-accessory', s.accessoryHandles.indexOf(p.handle) > -1);
    });
    html += '</div>';

    html += '</section>';
    return html;
  };

  Configurator.prototype.renderSummary = function () {
    var items = this.getSelectedItems();
    var list = this.els.summaryList;
    list.innerHTML = '';

    if (items.length === 0) {
      var empty = document.createElement('li');
      empty.className = 'qx-summary__row qx-summary__row--empty';
      empty.textContent = 'Inizia scegliendo la staffa.';
      list.appendChild(empty);
      this.els.total.textContent = '—';
      this.els.addBtn.disabled = true;
      return;
    }

    var total = 0;
    items.forEach(function (item, idx) {
      total += item.price_cents || 0;
      var row = document.createElement('li');
      row.className = 'qx-summary__row';
      row.innerHTML =
        (item.image ? '<img class="qx-summary__thumb" src="' + item.image + '" alt="">' : '<div class="qx-summary__thumb"></div>') +
        '<div><div class="qx-summary__cat">' + escapeHtml(item.cat) + '</div>' +
        '<div class="qx-summary__name">' + escapeHtml(item.title) + '</div></div>' +
        '<div class="qx-summary__price">' + money(item.price_cents) +
          '<button type="button" class="qx-summary__remove" aria-label="Rimuovi" data-remove="' + idx + '">×</button>' +
        '</div>';
      list.appendChild(row);
    });

    list.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var i = parseInt(btn.getAttribute('data-remove'), 10);
        if (items[i] && items[i].remove) items[i].remove();
      });
    });

    this.els.total.textContent = money(total);
    this.els.addBtn.disabled = items.length === 0;
  };

  // ---------- Event delegation -----------------------------------------

  Configurator.prototype.attachStepHandlers = function () {
    var self = this;
    this.els.steps.querySelectorAll('[data-action]').forEach(function (el) {
      var action = el.getAttribute('data-action');

      if (action === 'set-case-variant' && el.tagName === 'SELECT') {
        el.addEventListener('change', function () {
          if (el.value) self.setCaseVariant(el.getAttribute('data-handle'), el.value);
        });
        return;
      }

      el.addEventListener('click', function () {
        if (el.hasAttribute('disabled')) return;
        switch (action) {
          case 'set-filter':          self.setTagFilter(el.getAttribute('data-id')); break;
          case 'toggle-support':      self.toggleSupport(el.getAttribute('data-handle')); break;
          case 'continue-to-cases':   self.continueToCases(); break;
          case 'continue-to-extras':  self.continueToExtras(); break;
          case 'toggle-case':         self.toggleCase(el.getAttribute('data-handle')); break;
          case 'toggle-accessory':    self.toggleAccessory(el.getAttribute('data-handle')); break;
        }
      });
    });
  };

  // ---------- Init ------------------------------------------------------

  function init() {
    var root = document.getElementById('qx-config-root');
    if (!root) return;
    try {
      var data = readJsonScript('qx-shopify-data');
      var configurator = new Configurator(root, data);
      configurator.render();
      window.__qxConfigurator = configurator;
    } catch (err) {
      console.error('[QUIKLOX] Init failed', err);
      root.setAttribute('data-state', 'error');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
